export class Identity {
  public email?: string;
  public accessToken?: string;
  public tokenExpirationDate?: number;
  public refreshToken?: string;
  public roles?: string[];
}
